export const FIREBASE_API_URL = "https://us-central1-berylls.cloudfunctions.net/api";
// export const FIREBASE_API_URL = "http://localhost:5000/berylls/us-central1/api";
export const API_URL = 'https://backend.cap.berylls-index.com/v1';
